// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  REACT_APP_COGNITO_USER_POOL_REGION: "eu-north-1",
  REACT_APP_COGNITO_USER_POOL_ID: "eu-north-1_79KfHwyHr",
  REACT_APP_COGNITO_APP_CLIENT_ID: "14d6f3t08umb3nr3f5r6egqc6s",
  apiUrl: "https://api.development.mag8000.siemens.com",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
